import { render, staticRenderFns } from "./BoxesOverview.vue?vue&type=template&id=1f26d4f8"
import script from "./BoxesOverview.vue?vue&type=script&lang=js"
export * from "./BoxesOverview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports